import SalePage from "./SalePage";

export default SalePage;
